import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { CustomInput } from 'ui-library';
import { DatePickerComponent } from '../forms/date-picker/date-picker.component';

@Component({
  selector: 'lib-custom-input',
  imports: [
    TranslateModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    MatRadioModule,
    MatCheckboxModule,
    MatChipsModule,
    MatSelectModule,
    DatePickerComponent
  ],
  standalone: true,
  templateUrl: './custom-input.component.html',
  styleUrl: './custom-input.component.scss'
})

export class CustomInputComponent {
  @Input() config!: CustomInput;
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  defaultDate: string = new Date().toISOString();

  onValueChange(event: any) {
    let value;
    
    switch (this.config.type) {
      case "text":
      case "number":
      case "password":
        value = event.target.value;
        break;

      case "checkbox":
        value = event.checked;
        break;

      case "date":
        value = event;
        break;
    }

    if (this.config.update) {
      this.config.update(event)
    }

    if (this.onChange) {
      this.onChange.emit(this.config)
    }
  }

  onDateChanged(newDate: string) {
    this.config.value = newDate;
    this.onValueChange(newDate);
  }

  getTypeIcon(type: string): string {
    const icons: { [key: string]: string } = {
      'text': 'text_fields',
      'number': 'pin',
      'password': 'lock',
      'select': 'list',
      'date': 'calendar_today',
      'checkbox': 'check_box'
    };
    return icons[type] || 'help';
  }
}
